export default __webpack_public_path__ + "static/media/patients-icon.2647c2a1.svg";